export default "__VITE_ASSET__BjmxNuYX__"